import React from 'react';
import CatalogoP from '../catalagobase/catalogobase';
import Navbar from '../../components/navbar/navbar';
import Sidebar from '../../components/sidebar/sidebar';
import { API_URLS } from '../../Services/servicioURL';

function Marcas() {
    return (
        <div>
            <Navbar />
            <Sidebar />
            <CatalogoP title="Marcas" apiUrls={API_URLS.marcas}/>
        </div>
        
    
    );
}

export default Marcas;